<template lang="pug">
  .maptooltip(v-bind:style='pos')
    .maptooltip_panel( ref="tooltippanel")
      .maptooltip_value
        |{{value}}
      .maptooltip_type
        .maptooltip_label
          |{{type}}
        .maptooltip_unit(v-if='with_unit')
          svg(width="14" height="15" viewBox="0 0 14 14")
            path(d="M13 0h1L1 14h-1" fill="#000")
          |100,000

      .maptooltip_line(v-bind:style="{backgroundColor: color}")
      .maptooltip_location
        |{{location}}
    svg.maptooltip_svg(width="13" height="13" viewBox="0 0 13 13")
      path(d="M0 0h13L0 13v-13")

</template>
<script>
  import {mapState} from 'vuex';
  
  export default {
    props: ['value', 'color', 'location', 'mouse'],
    data: () => {
      return {
        width: 120 + 10,
        height: 110 + 13 + 10
      }
    },
    computed: {
      ...mapState([
        'lang',
        'selected',
        'size',
      ]),
      type: function (){
        return /ja/.test(this.lang) ? this.selected.type.name : this.selected.type.label;
      },
      pos: function(){
        return {
          top: Math.min( Math.max(this.mouse.y, this.height), this.size.svg.height ) + 'px',
          left: Math.min( Math.max( this.mouse.x, 10), this.size.svg.width - this.width ) + 'px'
        };
      },
      with_unit(){
        return !(this.selected.type.value == 'Life_expectancy' || this.selected.type.value == 'HALE');
      }
    }

  }
</script>
<style lang="sass">
  .maptooltip
    box-shadow: 3px 3px 3px rgba(0, 0, 0, .3)
    position: absolute
    transform: translate(-10px, calc(-100% - 18px))
    pointer-events: none

    &_panel
      background-color: #fff
      min-width: 120px
      min-height: 110px
      box-sizing: border-box
      padding: 10px
    &_value
      font-weight: bold
      font-size: 32px
      line-height: 1
      white-space: nowrap
      text-align: left
      margin-bottom: 10px
    &_type
      display: flex
      align-items: center
    &_label
      font-size: 16px
      line-height: 1
      white-space: nowrap
    &_unit
      font-size: 14px
      line-height: 1
      white-space: nowrap
      svg
        margin: 0 3px
    &_line
      width: 100%
      height: 4px
      margin: 4px 0 10px
    &_location
      line-height: 1
      font-weight: bold
      font-size: 18px
    &_svg
      position: absolute
      bottom: -13px
      left: 9px
      path
        fill: #fff

</style>